import { ALL_SALES_FAIL, ALL_SALES_REQUEST, ALL_SALES_SUCCESS, ALL_SHOP_ORDER_SALES_FAIL, ALL_SHOP_ORDER_SALES_REQUEST, ALL_SHOP_ORDER_SALES_SUCCESS } from "app/utils/constants/salesConstants";

const INIT_STATE = {
  loading: false,
  error: null,
  allSales: [],
  allShopOrderSales: [],
  TotalPage: null,
};

const INIT_STATE_SHOP_ORDER = {
  loading: false,
  error: null,
  allShopOrderSales: [],
  TotalPage: null,
};

export const salesReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Normal Order
    case ALL_SALES_REQUEST:
      return {
        loading: true,
      };
    case ALL_SALES_SUCCESS:
      return {
        ...state,
        loading: false,
        allSales: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_SALES_FAIL:
      return {
        loading: false,
        allSales: [],
        error: action.payload,
      };

    // Shop Order
    case ALL_SHOP_ORDER_SALES_REQUEST:
      return {
        loading: true,
      };
    case ALL_SHOP_ORDER_SALES_SUCCESS:
      return {
        ...state,
        loading: false,
        allShopOrderSales: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_SHOP_ORDER_SALES_FAIL:
      return {
        loading: false,
        allShopOrderSales: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export const shopOrderSalesReducer = (state = INIT_STATE_SHOP_ORDER, action) => {
  switch (action.type) {
    case ALL_SHOP_ORDER_SALES_REQUEST:
      return {
        loading: true,
      };
    case ALL_SHOP_ORDER_SALES_SUCCESS:
      return {
        ...state,
        loading: false,
        allShopOrderSales: action.payload.data,
        TotalPage: action.payload.totalPage,
      };

    case ALL_SHOP_ORDER_SALES_FAIL:
      return {
        loading: false,
        allShopOrderSales: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
